import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the notification api
 */
export class NotificationService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getNotificationCurrentUser(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var nodes = await this.makeGETRequest('/api/resource/notifications' + params);		
		return nodes;
	}
	
	async getNotificationAll(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var nodes = await this.makeGETRequest('/api/resource/notifications/all' + params);		
		return nodes;
	}

	exportNotifications(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/notifications/export' + params);
	}

	exportNotificationsAll(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/notifications/all/export' + params);
	}
	
	async markAsRead(notificationId) {	
		var result = await this.makePUTRequest('/api/resource/notifications/' + notificationId + '/read');
		return result;
	}	

	async markAsUnRead(notificationId) {	
		var result = await this.makePUTRequest('/api/resource/notifications/' + notificationId + '/unread');
		return result;
	}
	
	async deleteNotification(notificationId) {		
		var result = await this.makeDELETERequest('/api/resource/notifications/' + notificationId);		
		return result;
	}
	
	async deleteAllNotificationsForUser() {		
		var result = await this.makeDELETERequest('/api/resource/notifications/currentuser');		
		return result;
	}	
	
	async postNotification(notification) {
		var saved = this.makePOSTRequest('/api/resource/notifications', notification);	
		return saved;
	}
	
};

